import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getCookiesInfo = () => {
  const url = API_URLS.cookieInfo;
  return axiosClient.get(url);
};
export const getPrivacyPolicyInfo = () => {
  const url = API_URLS.privacyPolicyInfo;
  return axiosClient.get(url);
};
